module.exports = __webpack_public_path__ + "img/track-left.060f7282.png";